import Icon from '@ant-design/icons';
import { FileOutlined } from '@ant-design/icons';
import { SearchOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { Enviroment } from '../../../../_config/constants/enviroment-v2.constant';
import { UnixToDate } from '../../../../_config/utils/unix-to-date.util';
import { ColumnTitles } from '../constants/column-titles.constant';
import { statusDescription } from '../constants/status-description.constant';
import { dropdownOptionsDelivery } from './dropdown-options-delivery.handle';
import { dropdownOptionsStatus } from './dropdown-options-status.handle';
import { typeDelivery } from './type-delivery.handle';
import { handleNotificationClick } from '../../../../_config/functions/check-notification-and-mark-as-read';

export const generateColumns = (itemsDropdownDelivery, itemsDropdownSelect, status) => {
	return [
		{
			title: ColumnTitles[Enviroment.LANGUAGE].trx_id,
			dataIndex: 'trx_id',
			key: 'trx_id',
		},
		{
			align: 'center',
			title: ColumnTitles[Enviroment.LANGUAGE].operation_id,
			dataIndex: 'reserve_id',
			key: 'reserve_id',
		},
		{
			align: 'center',
			title: ColumnTitles[Enviroment.LANGUAGE].pharmacy,
			dataIndex: 'pharmacy',
			key: 'pharmacy',
		},
		{
			title: dropdownOptionsDelivery(itemsDropdownDelivery),
			dataIndex: 'delivery_type',
			key: 'delivery_type',

			render: (deliveryType) => typeDelivery(deliveryType),
		},
		{
			title: dropdownOptionsStatus(status, itemsDropdownSelect),
			dataIndex: 'status',
			key: 'status',
			render: (deliveryTypeObj) => {
				return statusDescription[Enviroment.LANGUAGE][deliveryTypeObj.status];
			},
		},
		{
			title: ColumnTitles[Enviroment.LANGUAGE].createdAt,
			dataIndex: 'createdAt',
			key: 'createdAt',

			render: (createdAt) => UnixToDate(createdAt),
		},
		{
			align: 'center',
			title: ColumnTitles[Enviroment.LANGUAGE].url_voucher,
			dataIndex: 'url_voucher',
			key: 'url_voucher',
			render: (url_voucher) => {
				return (
					<a className="link-voucher" href={url_voucher} target="_blank" rel="noreferrer noopener">
						<Icon className="link-voucher" component={FileOutlined} />
					</a>
				);
			},
		},
		{
			align: 'center',
			title: ColumnTitles[Enviroment.LANGUAGE].detailOrder,
			dataIndex: 'detailOrder',
			key: 'detailOrder',
			render: (detailOrder, record) => {
				console.log('detailOrder', record);
				return (
					<Link
						to={`/v2/tracking/detail/${record.pharmacy}/${record.trx_id}`}
						onClick={() => handleNotificationClick(record?.trx_id, record?.pharmacy)}
					>
						<Icon className="link-voucher" component={SearchOutlined} />
					</Link>
				);
			},
		},
	];
};
